import client from '@libs/HttpClient';
class ProjectService {
  //Project Master
  static listProject(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];
    const managerID = request.queryKey[4] || '';
    const qaID = request.queryKey[5] || '';
    const clientID = request.queryKey[6] || '';
    const teamMemberID = request.queryKey[7] || '';
    const deliveryManagerID = request.queryKey[8] || '';
console.log(deliveryManagerID);
    return client.get(
      `/projects/?search=${searchText}&page=${page_no}&status=${status}&manager_id=${managerID}&qa_id=${qaID}&client_id=${clientID}&team_member_id=${teamMemberID}&delivery_manager_id=${deliveryManagerID}`,
      request
    );
  }
  static addProject(request) {
    return client.post(`/projects`, request);
  }
  static viewProject(params) {
    return client.get(`/projects/${params}/edit`);
  }
  static showProject(params) {
    return client.get(`/projects/${params}`);
  }
  static updateProject(request) {
    return client.put(`/projects/${request.id}`, request);
  }
  static deleteProject(request) {
    return client.delete(`/projects/${request.id}`, request);
  }
  static employeeList(request) {
    const get_all = request.queryKey[1] ?? 0;
    return client.get(`/employee-list?all=${get_all}`, request);
  }
  static clientList(request) {
    const get_all = request.queryKey[1] ?? 0;
    return client.get(`/client-list?all=${get_all}`, request);
  }
  static projectManagerList(request) {
    return client.get(`/project-manager-list`, request);
  }
  static projectQaList(request) {
    return client.get(`/project-qa-list`, request);
  }
  static projectTeamMemberList(request) {
    return client.get(`/project-team-member-list`, request);
  }
  static deliveryManagerList(request) {
    return client.get(`/delivery-manager-list`, request);
  }
}
export { ProjectService };
